import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Megaphone } from 'lucide-react';

const AnnouncementButton: React.FC = () => {
  const [hovered, setHovered] = useState(false);
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    // let the expand animation finish before navigating
    setTimeout(() => navigate('/announcements'), 180);
  };

  return (
    <>
      <style>{`
        @keyframes announcementPulse {
          0% { box-shadow: 0 0 0 0 rgba(0,91,102,0.5); }
          70% { box-shadow: 0 0 0 14px rgba(0,91,102,0); }
          100% { box-shadow: 0 0 0 0 rgba(0,91,102,0); }
        }
      `}</style>

      <motion.a
        href="/announcements"
        onClick={handleClick}
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.15, type: 'spring', stiffness: 260, damping: 18 }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          position: 'fixed',
          bottom: 110,
          right: 28,
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          background: '#005B66',
          color: '#fff',
          borderRadius: hovered ? 40 : 50,
          padding: hovered ? '14px 20px' : '14px',
          boxShadow: '0 4px 20px rgba(0,91,102,0.4)',
          textDecoration: 'none',
          transition: 'all 0.3s',
          animation: 'announcementPulse 2.5s infinite',
          overflow: 'hidden',
          maxWidth: hovered ? 230 : 52,
          cursor: 'pointer',
        }}
        aria-label="View Announcements"
      >
        <span style={{ position: 'relative', display: 'flex', flexShrink: 0 }}>
          <Megaphone size={22} strokeWidth={2} />
          <span
            style={{
              position: 'absolute',
              top: -3,
              right: -3,
              width: 9,
              height: 9,
              borderRadius: '50%',
              background: '#D62828',
              border: '2px solid #005B66',
            }}
          />
        </span>
        {hovered && (
          <span
            style={{
              fontSize: 13,
              fontWeight: 600,
              fontFamily: 'Poppins, sans-serif',
              whiteSpace: 'nowrap',
            }}
          >
            Announcements
          </span>
        )}
      </motion.a>
    </>
  );
};

export default AnnouncementButton;